import React from "react";
import cn from "./helpers/cn";

interface OptionProps extends React.OptionHTMLAttributes<HTMLOptionElement> {
  children: React.ReactNode;
}

const Option = ({ children, value, className, ...other }: OptionProps): JSX.Element => {
  return (
    <option
      value={value}
      className={cn(
        "bg-white text-primary-tx py-2", // Estilização limitada pelo browser em selects nativos
        className
      )}
      {...other}
    >
      {children}
    </option>
  );
};

export default Option;